export const acrylicfigure = () => {};
